export interface IMigrateProjectProcessPayload {
    migratingProjects: ProcessMigrationModel[];
}

export interface ProcessMigrationModel {
    newProcessTypeId: string;
    projectId: string;
}